<template>
  <div class="variants">
    <div class="variants-holder" ref="variantSection"></div>
    <hr />
    <nav class="panel" v-if="active" :class="{'is-highlighted': panelHighlight}">
      <div class="panel-heading is-clearfix">
        <div class="left">
          <div v-if="active.image || active.thumbnail">
            <vue-gallery
              :images="[active.image || active.thumbnail]"
              :index="index"
              @close="index = null"
            ></vue-gallery>
            <div class="clearfix" style="margin: 0 -5px">
              <figure @click="index = 1" class="image is-64x64">
                <img :src="active.thumbnail || active.image" />
              </figure>
            </div>
          </div>
          <span>{{active.name}} - {{active.price | currency('eur')}}</span>
        </div>
        <div class="is-pulled-right">
          <nuxt-link
            :to="
                  localePath('office-products-fittings-id-variant-edit')
                "
            class="button is-link is-small m-r-2"
          >
            <i class="mdi mdi-pencil"></i>
          </nuxt-link>
          <button
            @click="removeVariant"
            class="button is-small is-danger"
            :class="{'is-loading': removeVariantLoading}"
          >
            <i class="mdi mdi-trash-can-outline"></i>
          </button>
        </div>
      </div>

      <nuxt-child />
    </nav>
  </div>
</template>

<script>
import VueGallery from "vue-gallery";

export default {
  validate({ store, params }) {
    const active = store.state.fittings.active;
    return !active || active.variants.find(e => e.id == params.variant);
  },

  async asyncData({ store, params }) {
    await store.dispatch("fittings/setVariant", params.variant);
  },

  components: {
    VueGallery
  },

  data() {
    return {
      removeVariantLoading: false,
      panelHighlight: true,
      index: null
    };
  },

  mounted() {
    this.highlightVariant();
  },

  watch: {
    "$route.params.variant": function() {
      this.highlightVariant();
    }
  },

  computed: {
    active() {
      return this.$store.state.fittings.variant;
    }
  },

  methods: {
    highlightVariant() {
      this.panelHighlight = true;

      this.$refs.variantSection.scrollIntoView({ behavior: "smooth" });

      this.$nextTick(() => {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
        this.timer = setTimeout(() => {
          this.panelHighlight = false;
        }, 700);
      });
    },

    async removeVariant() {
      if (confirm(this.$t("message.are_you_sure"))) {
        this.removeVariantLoading = true;

        try {
          await this.$api.deleteFittingVariant(
            this.$route.params.id,
            this.active.id
          );
          this.$store.commit("fittings/REMOVE_VARIANT", this.active.id);
          this.$router.replace(this.localePath("office-products-fittings-id"));
          this.$store.commit("fittings/SET_VARIANT", null);
        } catch (e) {
          console.log(e);
          this.handleFormError(e.response.data);
        }

        this.removeVariantLoading = false;
      }
    }
  }
};
</script>


<style lang="scss" scoped>
.variants {
  position: relative;

  &-holder {
    position: absolute;
    top: -80px;
    bottom: 0;
    left: 0;
    pointer-events: none;
  }
}

.panel-heading {
  .left {
    display: inline-flex;
    align-items: center;
    width: auto;

    .image {
      margin-right: 15px;
      cursor: pointer;
      display: flex;
      border: 1px solid #dbdbdb;
      background-color: lighten(#dbdbdb, 10%);

      img {
        margin: auto;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// resources/nuxt/pages/office/products/fittings/_id/_variant.vue